import { swapCoordinatesArr } from '../util/helpers';
/**
 * Calls the GET request with optional filter parameters
 *
 * - Todo: need to include modifiedFrom & modifiedTo params
 * @param brand
 * @param communityId
 * @param lotId
 * @returns
 */
export function getGeoJson(mapApiKey, brand, communityId, lotId, bypassCache) {
    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': mapApiKey
        }
    };
    if (bypassCache) {
        options.headers = { ...options.headers,
            'cache-control': 'no-cache',
            'pragma': 'no-cache' };
    }
    const requestString = '/api/maps/geojson' +
        (brand ? `?brand=${brand}` : '') +
        (communityId ? `&communityId=${communityId}` : '') +
        (lotId ? `&lotId=${lotId}` : '') +
        (bypassCache ? `&bypassCache=${bypassCache}` : '');
    return fetch(requestString, options);
}
export function getGeoJsonId(mapApiKey, brand, communityId, lotId, POIname) {
    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': mapApiKey
        }
    };
    const requestString = '/api/maps/getgeojsonid' +
        `?brand=${brand}` +
        (communityId ? `&communityId=${communityId}` : '') +
        (POIname ? `&placeOfInterestName=${POIname}` : '') +
        (lotId ? `&lotId=${lotId}` : '');
    return fetch(requestString, options);
}
/**
 * Posts a new polygon
 *
 * - Todo: match up PolygonStore type to match more closely and add more properties to type
 * @param polygon
 * @param brand
 * @param communityId
 * @returns
 */
export function createGeoJson(mapApiKey, polygon, brand, communityId) {
    if (brand) {
        polygon.Properties.Brand = brand;
    }
    if (communityId) {
        polygon.Properties.CommunityId = communityId;
    }
    let copyCoordinates = JSON.parse(JSON.stringify(polygon.Coordinates));
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': mapApiKey
        },
        body: JSON.stringify({
            Feature: {
                Coordinates: swapCoordinatesArr(copyCoordinates), //swap coordinates to support LONG,LAT format
                Properties: {
                    Brand: polygon.Properties.Brand,
                    CommunityId: polygon.Properties.CommunityId,
                    LotId: polygon.Properties.LotId,
                    Type: polygon.Properties.Type,
                    Name: polygon.Properties.Name,
                    LotIdOrientation: polygon.Properties.LotIdOrientation
                },
                Type: polygon.Type
            }
        })
    };
    return fetch('/api/maps/geojson', options);
}
export function updateGeoJson(mapApiKey, id, polygon) {
    let copyCoordinates = JSON.parse(JSON.stringify(polygon.Coordinates));
    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': mapApiKey
        },
        body: JSON.stringify({
            Feature: {
                Coordinates: swapCoordinatesArr(copyCoordinates), //swap coordinates to support LONG,LAT format
                Properties: {
                    Brand: polygon.Properties.Brand,
                    CommunityId: polygon.Properties.CommunityId,
                    LotId: polygon.Properties.LotId,
                    Type: polygon.Properties.Type,
                    Name: polygon.Properties.Name,
                    LotIdOrientation: polygon.Properties.LotIdOrientation
                },
                Type: polygon.Type
            }
        })
    };
    return fetch('/api/maps/geojson/' + id, options);
}
export async function removeGeoJson(mapApiKey, id) {
    if (id === '') {
        throw new Error('Cannot remove polygon with empty ID');
    }
    const options = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': mapApiKey
        }
    };
    return fetch(`/api/maps/geojson/${id}`, options);
}
export async function handlePostGeoJson(mapApiKey, polygon, brand, communityId) {
    try {
        const response = await createGeoJson(mapApiKey, polygon, brand, communityId);
        const result = await response.json();
        if (!response.ok) {
            console.error('handle post geo JSON error: ', result);
            return { success: false, message: result };
        }
        else {
            return { success: true, message: result, data: result };
        }
    }
    catch (err) {
        return { success: false, message: err };
    }
}
export async function handlePutGeoJson(mapApiKey, id, polygon) {
    try {
        const response = await updateGeoJson(mapApiKey, id, polygon);
        const result = await response.json();
        if (!response.ok) {
            console.error('handle PUT geo JSON error: ', result);
            return { success: false, message: result };
        }
        else {
            return { success: true, message: result, data: result };
        }
    }
    catch (err) {
        console.log('err');
        return { success: false, message: err };
    }
}
export async function handleGetGeoJsonId(mapApiKey, brand, communityId, lotId, POIname) {
    try {
        const response = await getGeoJsonId(mapApiKey, brand, communityId, lotId, POIname);
        const result = await response.json();
        if (!response.ok) {
            console.error('getGeoJsonId geo JSON error: ', result);
            return { success: false, message: result };
        }
        else {
            return { success: true, message: result };
        }
    }
    catch (err) {
        return { success: false, message: err };
    }
}
